export default __webpack_public_path__ + "static/media/illustration-recruit-3-m@2x.daa6aed4.webp";